import React, {useEffect, useState} from "react";
import {useAppSelector} from "../../../../redux/hooks/hook";
import {stLabel} from "../../../../constants/game";
import {moneyFormatter} from "../../../../../_kiloit/helpers/components/MoneyUtils";
import {TicketModal} from "../../../print/TicketModal";
import Printer from "../../../print/Printer";
import {drawStatus} from "../../../../constants/general";
import _ from "lodash";
import {toAbsoluteUrl} from "../../../../../_kiloit/helpers";
import RefreshBtn from "../../../../../_kiloit/partials/widgets/RefreshButton";
import {useGame} from "../../../game/core/action";
import {useParams} from "react-router-dom";
import {NumericFormat} from "react-number-format";
import {getCSize, getLocalSt, setLocalSt, stKeys} from "../../../../../_kiloit/helpers/storage";
import {I18n} from "../../../../../_kiloit/i18n/KiloITi18n";


const RecentBet = ({size, setSize}) => {
    const {list} = useAppSelector(state => state.gameState.game.currentBet);
    const [ticketDl, setTicket] = useState<any>();
    const {fetchCurrentBet, fetchCurrentDraw} = useGame();
    const param = useParams();
    const tableId = parseInt(param.id ?? "0");

    useEffect(() => {
        setSize(getCSize());
    }, [setSize])

    const onChangeSize = (e) => {
        setLocalSt(stKeys.currentBet, e);
        setSize(e);
    }

    const onFilter = () => {
        fetchCurrentBet({size, tableId})
    }

    const [isChecked, setIsChecked] = useState(false);

    const handleCheckboxChange = () => {
        const checkedValue = !isChecked;
        setIsChecked(checkedValue);
        setLocalSt("isChecked", JSON.stringify(checkedValue));
    };

    const handleAfterPrint = () => {
        fetchCurrentDraw(tableId, false);
    }

    useEffect(() => {
        const storedValue = getLocalSt("isChecked")
        if (storedValue !== null) {
            setIsChecked(JSON.parse(storedValue));
        }
    }, []);


    return <div id="current-bet-report" className=" h-xl-500px overflow-y-scroll">
        <div className="d-flex justify-content-between align-items-center text-light ticket-dice p-2">
            <span className="text-light fw-bold fs-3"><I18n t={"RECENT_BET"}/></span>

            <NumericFormat
                className="fs-3 fw-bold in-recent-size ms-auto"
                // @ts-ignore
                isAllowed={({value}) => value < 11}
                value={size}
                onBlur={onFilter}
                onValueChange={(e) => {
                    onChangeSize(e.value)
                }}

            />

            <div className="ms-auto">
                <i
                    className={`bi bi-printer fw-bold fs-3 cursor-pointer text-white p-1 rounded ${isChecked ? "bg-info" : ""}`}
                    onClick={handleCheckboxChange}
                />
            </div>

            <RefreshBtn onRefresh={onFilter}/>
        </div>
        {
            _.isEmpty(list) ? <div className="d-flex justify-content-center align-items-center">
                <img className="empty-img" src={toAbsoluteUrl("/media/game/empty.svg")} alt=""/>
            </div> : list.map((draw, index) => {
                const res = draw.results.filter(e => e.betCode === "SLOT")[0];
                return <div className="fw-bolder fs-4" key={index}>
                    <div className="fs-3 bg-ticket-header text-black text-start ps-2 py-1">{draw.drawLabel}
                        {draw.status === drawStatus.released &&
                            <span className="float-end me-5 text-blue"><I18n
                                t={"RESULT"}/> ( {stLabel[res.result!]} )</span>}
                    </div>
                    {draw.tickets.map((ticket, i) => {
                        const ts = {...ticket, status: draw.status === 2, drawLabel: draw.drawLabel};
                        return <table key={i} className="w-100 border-bottom">
                            <tbody className="header-div-white">
                            {/*<tr className="">*/}
                            {/*    <th className="text-start px-2 py-1"*/}
                            {/*        colSpan={7}>*/}
                            {/*        <div*/}
                            {/*            onClick={() => setTicket(ts)}*/}
                            {/*            className="fs-4 text-blue text-decoration-underline cursor-pointer">{ticket.ticketNumber}</div>*/}
                            {/*    </th>*/}
                            {/*    <th className='px-2 py-1'>*/}
                            {/*        <Printer ticket={ts}*/}
                            {/*                 onAfterPrint={() => {*/}
                            {/*                 }}/>*/}
                            {/*    </th>*/}
                            {/*</tr>*/}
                            <tr>
                                <td>
                                    {ticket.items.map((item, j) => {
                                        return <div key={j} className="d-flex text-start p-2">
                                            <div className="d-flex justify-content-start w-100">
                                                <div className="w-45px">{stLabel[item.betCode]}</div>
                                                <span>{moneyFormatter(item.betAmount)} </span>
                                                <div className="pe-1 ps-1">x</div>
                                                <div>{item.rebateValue}</div>
                                                <div className="pe-1 ps-1">=</div>
                                                <span className="text-danger">{
                                                    draw.status === 2 ?
                                                        moneyFormatter(item.winAmount)
                                                        : "???"

                                                }</span>
                                            </div>
                                            <div className="me-2">
                                                {(item.isWin || draw.status < drawStatus.released) &&
                                                    <Printer ticket={ts}
                                                             onAfterPrint={handleAfterPrint}/>}
                                            </div>
                                        </div>
                                    })}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    })}
                </div>
            })}
        {ticketDl && <TicketModal onClose={() => setTicket(null)} ticket={ticketDl}/>}

    </div>
}
export default RecentBet;